import React from "react";
import "../App.css";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
//import CircularProgress from '@material-ui/core/CircularProgress';
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import IconButton from "@material-ui/core/IconButton";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";
//import CalendarIcon from '@material-ui/icons/CalendarToday';
//import Button from '@material-ui/core/Button';

//import CloseIcon from '@material-ui/icons/Close';

import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import ReactTooltip from "react-tooltip";
import * as d3 from "d3";
//import { FormHelperText } from '@material-ui/core';

import YearCalendar from "./yearCalendar";

const styles = (theme) => ({
  progress: {
    margin: theme.spacing() * 2,
  },
  container: {
    textAlign: "left",
    borderLeft: "3px solid #165469",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-start",
    minHeight: "125px",
    maxHeight: "125px",
    [theme.breakpoints.up("tablet")]: {
      minHeight: "140px",
      maxHeight: "140px",
    },
    [theme.breakpoints.up("md")]: {
      minHeight: "160px",
      maxHeight: "160px",
    },
  },
  selectorContainer: {
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    paddingLeft: "10px",
  },
  dateContainer: {
    flexDirection: "column",
    justifyContent: "center",
    minHeight: "60px",
    maxHeight: "60px",
  },
  dateSelector: {
    //padding: theme.spacing() * 2,
    margin: "0px",
    textAlign: "center",
    fontSize: "17px",
    fontFamily: "Flanders Art Sans",
    borderRadius: "0!important",
    minHeight: "60px",
    height: "60px",
    maxHeight: "60px",
    lineHeight: "30px",
  },
  yearSelector: {
    lineHeight: "60px!important",
    textAlign: "center",
    fontFamily: "Flanders Art Sans",
    fontSize: "17px",
  },
  borderLeftRounded: {
    borderTopLeftRadius: "10px!important",
    borderBottomLeftRadius: "10px!important",
    borderTopRightRadius: "0!important",
    borderBottomRightRadius: "0!important",
  },
  borderRightRounded: {
    borderTopRightRadius: "10px!important",
    borderBottomRightRadius: "10px!important",
  },
  questionContainer: {
    paddingTop: "1px",
    paddingBottom: "1px",
    //lineHeight: "60px!important",
  },
  fullHeight: {
    lineHeight: "60px!important",
  },
  tooltipIconButton: {
    padding: "0!important",
  },
  hoverable: {
    textDecoration: "none",
    "&:hover": {
      //color: 'white!important',
      cursor: "pointer",
      backgroundColor: "#dbdbdb",
    },
  },

  //spreader: {
  //  display: 'flex',
  //  justifyContent: 'center',
  //  marginTop: '0',
  //  marginBottom: '0',
  //  paddingTop: '6px',
  //  paddingBottom: '6px',
  //},
  active: {
    fontWeight: "700!important",
  },
  activeLink: {
    textDecoration: "underline",
    fontWeight: "700!important",
    "&:hover": {
      cursor: "pointer",
      backgroundColor: "#dbdbdb",
    },
  },
  toolTip: {
    textAlign: "left",
    color: "#165469!important",
    backgroundColor: "#aaaaaa",
    fontFamily: "Flanders Art Sans!important",
  },
  year: {
    color: "#165469!important",
    fontFamily: "Flanders Art Sans!important",
  },
});

function DateSelector(props) {
  const { classes } = props;
  
  let previousYear = parseInt(props.selectedYear) - 1;
  let nextYear = parseInt(props.selectedYear) + 1;
  
  const warningOneYearAgo = "Archief gaat één maand terug in de tijd";
  const warningAvailableTomorrow = "Beschikbaar vanaf morgen";
  const tooltipYearBeforeText = "Archief gaat terug tot 2014";
  const availableFromJanuary = "Vanaf februari " + nextYear + " beschikbaar";
  const locale = d3.timeFormatDefaultLocale({
    decimal: ",",
    thousands: ".",
    grouping: [3],
    currency: ["€", ""],
    dateTime: "%a %b %e %X %Y",
    date: "%d-%m-%Y",
    time: "%H:%M:%S",
    periods: ["AM", "PM"],
    days: [
      "zondag",
      "maandag",
      "dinsdag",
      "woensdag",
      "donderdag",
      "vrijdag",
      "zaterdag",
    ],
    shortDays: ["Zo", "Ma", "Di", "Wo", "Do", "Vr", "Za"],
    months: [
      "januari",
      "februari",
      "maart",
      "april",
      "mei",
      "juni",
      "juli",
      "augustus",
      "september",
      "oktober",
      "november",
      "december",
    ],
    shortMonths: [
      "Jan",
      "Feb",
      "Maa",
      "Apr",
      "Mei",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Okt",
      "Nov",
      "Dec",
    ],
  });

  const currentYear = parseInt(d3.timeFormat("%Y")(new Date()));
  let nextYearNavigationDisabled = (nextYear > currentYear) || (currentYear - 1 === props.selectedYear && props.currentYearNavigationDisabled)
  
  if (!props.showCalendar) {
    if (props.currentMode === "realtime") {
      let previousDay = d3.timeDay.offset(props.selectedDate, -1);
      let nextDay = d3.timeDay.offset(props.selectedDate, +1);

      //let oneYearAgoTomorrow = new Date(new Date().getTime() + 86400000)
      //oneYearAgoTomorrow.setYear(oneYearAgoTomorrow.getYear() - 1)

      let threeMonthsAgoTomorrow = new Date(new Date().getTime() + 86400000);
      threeMonthsAgoTomorrow.setMonth(threeMonthsAgoTomorrow.getMonth() - 3);

      let previousDayNavigationDisabled =
        nextDay.toDateString() === threeMonthsAgoTomorrow.toDateString();
      let nextDayNavigationDisabled =
        previousDay.toDateString() === new Date().toDateString();

      const tooltipDayBefore = (
        <ReactTooltip
          id="day_before_tooltip"
          type="light"
          place="left"
          className={classes.toolTip}
        >
          <p>{warningOneYearAgo}</p>
        </ReactTooltip>
      );

      const tooltipDayAfter = (
        <ReactTooltip
          id="day_after_tooltip"
          type="light"
          place="right"
          className={classes.toolTip}
        >
          <p>{warningAvailableTomorrow}</p>
        </ReactTooltip>
      );

      return (
        <Grid
          item
          container
          xs={12}
          className={classes.container + " darkbluegreen"}
        >
          <Grid
            item
            style={{ paddingBottom: "20px", paddingLeft: "5px", width: "100%" }}
          >
            Kies een{" "}
            <span
              className={classes.activeLink + " darkbluegreen"}
              onClick={() => props.displayCalendar(true, "realtime")}
            >
              dag
            </span>{" "}
            of{" "}
            <span
              className={classes.activeLink + " darkbluegreen"}
              //onClick={props.currentMode === "realtime"?props.changeMode:(()=>props.displayCalendar(true))}
              //onClick={props.changeMode}
              onClick={() => props.displayCalendar(true, "historical")}
            >
              jaar
            </span>
          </Grid>
          <Grid item container xs={12} className={classes.selectorContainer}>
            <Grid item container xs={4} className={classes.dateContainer}>
              {previousDayNavigationDisabled ? (
                <Paper
                  className={
                    classes.questionContainer +
                    " secondaryHeaderBackground headerText bgmediumgrey darkbluegreen " +
                    classes.hoverable +
                    " " +
                    classes.borderLeftRounded
                  }
                >
                  <IconButton
                    className={classes.tooltipIconButton}
                    data-for="day_before_tooltip"
                    data-tip="day_before_tooltip"
                  >
                    <HelpOutlineIcon />
                    {tooltipDayBefore}
                  </IconButton>
                </Paper>
              ) : (
                <Paper
                  className={
                    classes.dateSelector +
                    " secondaryHeaderBackground headerText bgmediumgrey darkbluegreen " +
                    classes.hoverable +
                    " " +
                    classes.borderLeftRounded
                  }
                  onClick={() =>
                    props.changeCurrentDaySelected(
                      d3.timeFormat("%Y%m%d")(previousDay)
                    )
                  }
                >
                  <div className="bold" style={{ fontSize: "1.1em" }}>
                    {d3.timeFormat("%A")(previousDay)}
                  </div>
                  <div>{d3.timeFormat("%e %B")(previousDay)}</div>
                </Paper>
              )}
            </Grid>
            <Grid item container xs={4} className={classes.dateContainer}>
              <Paper
                className={
                  classes.dateSelector + " activeHeaderText bgdarkbluegreen"
                }
              >
                <div className="bold" style={{ fontSize: "1.1em" }}>
                  {d3.timeFormat("%A")(props.selectedDate)}
                </div>
                <div>{d3.timeFormat("%e %B")(props.selectedDate)}</div>
                {/*
                  <IconButton className=  {classes.calendarIconButton}  onClick={()=>props.showCalendar(true)}>
                    <CalendarIcon />
                  </IconButton>
                  */}
              </Paper>
            </Grid>
            <Grid item container xs={4} className={classes.dateContainer}>
              {nextDayNavigationDisabled ? (
                <Paper
                  className={
                    classes.dateSelector +
                    " secondaryHeaderBackground headerText bgmediumgrey darkbluegreen " +
                    classes.questionContainer +
                    " " +
                    classes.borderRightRounded
                  }
                >
                  <div className="bold" style={{ fontSize: "1.1em" }}>
                    {d3.timeFormat("%A")(nextDay)}
                    <IconButton
                      className={classes.tooltipIconButton}
                      data-for="day_after_tooltip"
                      data-tip="day_after_tooltip"
                    >
                      <HelpOutlineIcon />
                      {tooltipDayAfter}
                    </IconButton>
                  </div>
                  <div>{d3.timeFormat("%e %B")(nextDay)}</div>
                </Paper>
              ) : (
                <Paper
                  className={
                    classes.dateSelector +
                    " secondaryHeaderBackground headerText bgmediumgrey darkbluegreen " +
                    classes.hoverable +
                    " " +
                    classes.borderRightRounded
                  }
                  onClick={() =>
                    props.changeCurrentDaySelected(
                      d3.timeFormat("%Y%m%d")(nextDay)
                    )
                  }
                >
                  <div className="bold" style={{ fontSize: "1.1em" }}>
                    {d3.timeFormat("%A")(nextDay)}
                  </div>
                  <div>{d3.timeFormat("%e %B")(nextDay)}</div>
                </Paper>
              )}
            </Grid>
          </Grid>
        </Grid>
      );
    } else {
      // historical mode
      let previousYearNavigationDisabled = previousYear < 2015;
      
      const tooltipYearBefore = (
        <ReactTooltip
          id="year_before_tooltip"
          type="light"
          place="left"
          className={classes.toolTip}
        >
          {tooltipYearBeforeText}
        </ReactTooltip>
      );
      const tooltipYearAfter = (
        <ReactTooltip
          id="year_after_tooltip"
          type="light"
          place="right"
          className={classes.toolTip}
        >
          {availableFromJanuary}
        </ReactTooltip>
      );

      return (
        <Grid
          item
          container
          xs={12}
          className={classes.container + " darkbluegreen"}
        >
          <Grid item style={{ paddingBottom: "20px", paddingLeft: "5px" }}>
            Kies een{" "}
            <span
              className={classes.activeLink + " darkbluegreen"}
              onClick={() => props.displayCalendar(true, "realtime")}
            >
              dag
            </span>{" "}
            of{" "}
            <span
              className={classes.activeLink + " darkbluegreen"}
              //onClick={props.currentMode === "realtime"?props.changeMode:(()=>props.displayCalendar(true))}
              //onClick={props.changeMode}
              onClick={() => props.displayCalendar(true, "historical")}
            >
              jaar
            </span>
          </Grid>
          <Grid item container xs={12} className={classes.selectorContainer}>
            <Grid
              item
              container
              xs={4}
              className={classes.dateContainer + " " + classes.yearContainer}
            >
              {previousYearNavigationDisabled ? (
                <Paper
                  className={
                    classes.questionContainer +
                    " bgmediumgrey headerText darkbluegreen " +
                    classes.hoverable +
                    " " +
                    classes.borderLeftRounded + " " + classes.yearSelector
                  }
                >
                  <IconButton
                    className={classes.tooltipIconButton}
                    data-for="year_before_tooltip"
                    data-tip="year_before_tooltip"
                  >
                    <HelpOutlineIcon />
                    {tooltipYearBefore}
                  </IconButton>
                </Paper>
              ) : (
                <Paper
                  className={
                    classes.dateSelector +
                    " " +
                    classes.yearSelector +
                    " bgmediumgrey headerText darkbluegreen " +
                    classes.hoverable +
                    " " +
                    classes.borderLeftRounded
                  }
                  data-year_selected={previousYear}
                  onClick={props.changeCurrentYearSelected}
                >
                  {previousYear}
                </Paper>
              )}
            </Grid>
            <Grid
              item
              container
              xs={4}
              className={classes.dateContainer + " " + classes.yearContainer}
            >
              <Paper
                className={
                  classes.dateSelector +
                  " " +
                  classes.yearSelector +
                  " bgdarkbluegreen activeHeaderText"
                }
              >
                <div className="bold" style={{ fontSize: "1.1em" }}>
                  {props.selectedYear}
                </div>
              </Paper>
            </Grid>
            <Grid item container xs={4} className={classes.dateContainer}>
              {nextYearNavigationDisabled ? (
                <Paper
                  className={
                    classes.questionContainer +
                    " bgmediumgrey darkbluegreen headerText " +
                    classes.borderRightRounded + " " + classes.yearSelector
                  }
                  
                >
                  {nextYear} &nbsp;
                  <IconButton
                    className={classes.tooltipIconButton}
                    data-for="year_after_tooltip"
                    data-tip="year_after_tooltip"
                  >
                    <HelpOutlineIcon />
                    {tooltipYearAfter}
                  </IconButton>
                </Paper>
              ) : (
                <Paper
                  className={
                    classes.dateSelector +
                    " " +
                    classes.yearSelector +
                    " bgmediumgrey darkbluegreen headerText " +
                    classes.hoverable +
                    " " +
                    classes.borderRightRounded
                  }
                  data-year_selected={nextYear}
                  onClick={props.changeCurrentYearSelected}
                >
                  {nextYear}
                </Paper>
              )}
            </Grid>
          </Grid>
        </Grid>
      );
    }
  } else {
    if (props.calendarMode === "realtime") {
      let activeStartDate = new Date();
      let minDate = new Date();
      minDate.setMonth(minDate.getMonth() - 3);
      const maxDate = new Date(new Date().getTime() + 86400000);

      return (
        <Grid item container xs={12}>
          <Calendar
            activeStartDate={activeStartDate}
            value={props.selectedDate ? props.selectedDate : activeStartDate}
            className="calendar"
            tileClassName="calendar"
            //locale={props.lang === 'de' ? 'de-DE' : (props.lang === 'en' ? 'en-GB' : 'fr-BE')}
            locale="nl"
            minDate={minDate}
            maxDate={maxDate}
            onChange={(value) => props.onDateChange(value)}
          />
        </Grid>
      );
    } else {
      //let minDate = new Date()
      //minDate.setMonth(minDate.getMonth() - 1)
      //const maxDate = new Date(new Date().getTime() + 86400000)

      //const minDate = new Date("2015-01-31");
      //const maxDate = new Date();
      //const selectedDate = new Date(props.selectedYear + '-01-31')

      const maxYear= new Date().getFullYear()-(props.currentYearNavigationDisabled?1:0)
      return (
        <Grid item container xs={12}>
          {/*
          <Calendar
            activeStartDate={minDate}
            //value={selectedDate}
            className="calendar"
            tileClassName="year"
            //locale={props.lang === 'de' ? 'de-DE' : (props.lang === 'en' ? 'en-GB' : 'fr-BE')}
            locale="nl"
            minDate={minDate}
            maxDate={maxDate}
            onChange={(value) => props.onYearChange(value)}
            maxDetail="decade"
            view="decade"
          />
        */}
          <YearCalendar
            minYear={2015}
            maxYear={maxYear}
            selectedYear={props.selectedYear}
            onChange={(value) => props.onYearChange(value)}
          ></YearCalendar>
        </Grid>
      );
    }
  }
}

DateSelector.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(DateSelector);
